import React, {useEffect, useState} from 'react';
import * as Constants from "../../utils/Constants";
import {getAuthToken} from '../../utils/utility';
import MapLink from '../../utils/MapLink';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope, faLocationDot, faMapLocationDot, faPhone, faUser} from "@fortawesome/free-solid-svg-icons";
import "../../styles/components/tasks.css";
import "../../styles/base/animations.css";

// FIX: Accepting 'task' prop directly
const TaskDetailsPanel = ({ task }) => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // FIX: Check for task.taskId (single level access)
        if (task && task.taskId) {
            fetchCustomers(task.taskId);
        }
    }, [task]);

    const fetchCustomers = (taskId) => {
        const endPoint = `${Constants.BASE_URL}${Constants.API_V1}/tasks/${taskId}/customers`;

        fetch(endPoint, {
            method: 'GET',
            headers: {
                'Authorization': `${Constants.BEARER} ${getAuthToken()}`
            }
        })
        .then(response => response.json())
        .then(data => {
            setCustomers(data || []);
            setLoading(false);
        })
        .catch(error => {
            console.error('Error fetching customers:', error);
            setLoading(false);
        });
    };

    return (
        <div className='task-details-panel'>
            <div className="panel-header-section">
                <h4 className="panel-title">
                    <FontAwesomeIcon icon={faMapLocationDot} /> &nbsp;
                    {/* FIX: Access task directly */}
                    Task Details (ID: {task?.taskId})
                </h4>
                <div className="panel-description">
                    <strong>Description: </strong> 
                    {task?.description ? task.description : <span className="text-muted">No description provided.</span>}
                </div>
            </div>

            {loading ? (
                <div className="panel-loading">
                    {[0,1,2].map(i => (
                        <div className="panel-loading-row" key={i}>
                            <div className="panel-loading-avatar" />
                            <div className="panel-loading-lines">
                                <div className="panel-loading-line long" />
                                <div className="panel-loading-line short" />
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <>
                    {customers.length === 0 ? (
                        <div className="panel-empty">No service locations found for this task.</div>
                    ) : (
                        <div className="customer-grid">
                            {customers.map((customer, index) => (
                                <div key={customer.taskLocationId || index} className="customer-detail-card">
                                    <div className="detail-card-header">
                                        <FontAwesomeIcon icon={faUser} className="icon-muted" /> 
                                        <span>{customer.customerDetail || "Unknown Customer"}</span>
                                    </div>
                                    
                                    <div className="detail-row">
                                        <FontAwesomeIcon icon={faLocationDot} className="row-icon" />
                                        <span>{customer.address}</span>
                                    </div>

                                    <div className="detail-row">
                                        <FontAwesomeIcon icon={faPhone} className="row-icon" />
                                        <span>{customer.phoneNumber}</span>
                                    </div>

                                    {customer.emailId && (
                                        <div className="detail-row">
                                            <FontAwesomeIcon icon={faEnvelope} className="row-icon" />
                                            <span>{customer.emailId}</span>
                                        </div>
                                    )}

                                    <div className="detail-actions">
                                        <span className="coord-badge">
                                            Lat: {Number(customer.latitude).toFixed(4)}, Lng: {Number(customer.longitude).toFixed(4)}
                                        </span>
                                        <div className="map-link-wrapper">
                                            <MapLink latitude={customer.latitude} longitude={customer.longitude} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default TaskDetailsPanel;